const CloseTooltipIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.23551 1.12859L7.94931 7.53385L14.6639 1.12859C14.8436 0.957137 15.135 0.957137 15.3149 1.12859C15.4946 1.30019 15.4946 1.57823 15.3149 1.74969L8.60033 8.15495L15.3149 14.561C15.4946 14.7324 15.4946 15.0105 15.3149 15.1821C15.1351 15.3535 14.8436 15.3535 14.6639 15.1821L7.94931 8.77606L1.23551 15.1821C1.0558 15.3535 0.764368 15.3535 0.584489 15.1821C0.40478 15.0105 0.40478 14.7324 0.584489 14.561L7.29829 8.15495L0.584489 1.74969C0.40478 1.57824 0.40478 1.3002 0.584489 1.12859C0.764352 0.957137 1.05579 0.957137 1.23551 1.12859Z"
        fill="white"
        stroke="white"
        stroke-width="0.75"
      />
    </svg>
  );
};

export default CloseTooltipIcon;
